import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { DownloadableConfigurationFiles } from '../../../_lib/components/ConfigurationFileUpload';

type ConfigurationFile = {
  fileExtension: 'csv';
  url: string;
};
type RolePrivilegeConfigurationDefaultProps = { files: ConfigurationFile[] };

function RolePrivilegeConfigurationDefault({ files }: RolePrivilegeConfigurationDefaultProps) {
  const { uuid, elementType } = useBlockContext();
  const { t } = useSonTranslation('RolePrivilegeConfig');
  return (
    <DownloadableConfigurationFiles
      key={`${elementType}-${uuid}`}
      files={files.map(file => ({
        extension: file.fileExtension,
        url: file.url,
        name: t('fileName'),
      }))}
    />
  );
}

export const RolePrivilegeConfigurationDefaultView = asView(RolePrivilegeConfigurationDefault);
export type RolePrivilegeConfigurationDefaultView = ComponentProps<typeof RolePrivilegeConfigurationDefaultView>;
